import Profiles from "../../../../pages/Profiles/Profiles";

// Wrapper que re-exporta el wizard existente de Patient Profiles
// para referenciarlo desde el modulo care-management-system
const PatientProfilesPage = Profiles;

export default PatientProfilesPage;
